export class TagArea{
  id: number;
  name: string;
  clasification: TagAreaClasification;

  constructor(clasification){
    this.clasification = clasification;
  }
}


export class TagAreaClasification {
  id: number;
  name: string;
  active?: boolean;
  constructor(id: number, name: string, active = false) {
    this.id = id;
    this.name = name;
    this.active = active;
  }
}
